import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoAdd, LazySvgoAlertWarning, LazySvgoArrowDiagonal, LazySvgoArrowDown, LazySvgoAttach, LazySvgoBadge, LazySvgoBin, LazySvgoBounty, LazySvgoBronzeTrophy, LazySvgoChangelog, LazySvgoChatUnread, LazySvgoChat, LazySvgoCheck, LazySvgoChevronDown, LazySvgoChevronLeft, LazySvgoChevronRight, LazySvgoClock, LazySvgoClose, LazySvgoCopy, LazySvgoDatabase, LazySvgoDiamond, LazySvgoDisclaimer, LazySvgoEdit, LazySvgoEmbed, LazySvgoEye, LazySvgoFixStatus, LazySvgoFolderPlus, LazySvgoFolder, LazySvgoGoldTrophy, LazySvgoInfo, LazySvgoLevel, LazySvgoLinkArrow, LazySvgoLink, LazySvgoLoadMore, LazySvgoLoader, LazySvgoLock, LazySvgoLogin, LazySvgoLogoSmall, LazySvgoLogo, LazySvgoLogout, LazySvgoMenu, LazySvgoNoData, LazySvgoPlus, LazySvgoPriority, LazySvgoRedeem, LazySvgoReport, LazySvgoRevoke, LazySvgoScan, LazySvgoSearch, LazySvgoSend, LazySvgoShield, LazySvgoSilverTrophy, LazySvgoSortAsc, LazySvgoSortDesc, LazySvgoSort, LazySvgoStatusActive, LazySvgoStatusInactive, LazySvgoTagHigh, LazySvgoTagLow, LazySvgoTagMedium, LazySvgoTarget, LazySvgoUpload, LazySvgoUploadV2, LazySvgoUploadV3, LazySvgoUser, LazySvgoVulnerableVersion, LazySvgoWordpress } from '#components'
const lazyGlobalComponents = [
  ["SvgoAdd", LazySvgoAdd],
["SvgoAlertWarning", LazySvgoAlertWarning],
["SvgoArrowDiagonal", LazySvgoArrowDiagonal],
["SvgoArrowDown", LazySvgoArrowDown],
["SvgoAttach", LazySvgoAttach],
["SvgoBadge", LazySvgoBadge],
["SvgoBin", LazySvgoBin],
["SvgoBounty", LazySvgoBounty],
["SvgoBronzeTrophy", LazySvgoBronzeTrophy],
["SvgoChangelog", LazySvgoChangelog],
["SvgoChatUnread", LazySvgoChatUnread],
["SvgoChat", LazySvgoChat],
["SvgoCheck", LazySvgoCheck],
["SvgoChevronDown", LazySvgoChevronDown],
["SvgoChevronLeft", LazySvgoChevronLeft],
["SvgoChevronRight", LazySvgoChevronRight],
["SvgoClock", LazySvgoClock],
["SvgoClose", LazySvgoClose],
["SvgoCopy", LazySvgoCopy],
["SvgoDatabase", LazySvgoDatabase],
["SvgoDiamond", LazySvgoDiamond],
["SvgoDisclaimer", LazySvgoDisclaimer],
["SvgoEdit", LazySvgoEdit],
["SvgoEmbed", LazySvgoEmbed],
["SvgoEye", LazySvgoEye],
["SvgoFixStatus", LazySvgoFixStatus],
["SvgoFolderPlus", LazySvgoFolderPlus],
["SvgoFolder", LazySvgoFolder],
["SvgoGoldTrophy", LazySvgoGoldTrophy],
["SvgoInfo", LazySvgoInfo],
["SvgoLevel", LazySvgoLevel],
["SvgoLinkArrow", LazySvgoLinkArrow],
["SvgoLink", LazySvgoLink],
["SvgoLoadMore", LazySvgoLoadMore],
["SvgoLoader", LazySvgoLoader],
["SvgoLock", LazySvgoLock],
["SvgoLogin", LazySvgoLogin],
["SvgoLogoSmall", LazySvgoLogoSmall],
["SvgoLogo", LazySvgoLogo],
["SvgoLogout", LazySvgoLogout],
["SvgoMenu", LazySvgoMenu],
["SvgoNoData", LazySvgoNoData],
["SvgoPlus", LazySvgoPlus],
["SvgoPriority", LazySvgoPriority],
["SvgoRedeem", LazySvgoRedeem],
["SvgoReport", LazySvgoReport],
["SvgoRevoke", LazySvgoRevoke],
["SvgoScan", LazySvgoScan],
["SvgoSearch", LazySvgoSearch],
["SvgoSend", LazySvgoSend],
["SvgoShield", LazySvgoShield],
["SvgoSilverTrophy", LazySvgoSilverTrophy],
["SvgoSortAsc", LazySvgoSortAsc],
["SvgoSortDesc", LazySvgoSortDesc],
["SvgoSort", LazySvgoSort],
["SvgoStatusActive", LazySvgoStatusActive],
["SvgoStatusInactive", LazySvgoStatusInactive],
["SvgoTagHigh", LazySvgoTagHigh],
["SvgoTagLow", LazySvgoTagLow],
["SvgoTagMedium", LazySvgoTagMedium],
["SvgoTarget", LazySvgoTarget],
["SvgoUpload", LazySvgoUpload],
["SvgoUploadV2", LazySvgoUploadV2],
["SvgoUploadV3", LazySvgoUploadV3],
["SvgoUser", LazySvgoUser],
["SvgoVulnerableVersion", LazySvgoVulnerableVersion],
["SvgoWordpress", LazySvgoWordpress],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
